module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Artisans-Haven-eca62a4553988a1ad2f8949663bcdbf9.jpg";